import { render, staticRenderFns } from "./svg-graph.vue?vue&type=template&id=a5a817ba&"
import script from "./svg-graph.ts?vue&type=script&lang=js&"
export * from "./svg-graph.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports